import { Component,OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { InsuranceApiService } from "@services/rest/insurance-api.service";
import { RoadTaxApiService } from "@services/rest/road-tax-api.service";
import { VerifyCustomerRequestModel, VerifyVehicleReponseModel } from "@model/quotation.model";
import { CalculateRoadTaxRequestModel, RoadTaxAddEditModel, RoadTaxSettings } from "@model/road-tax.model";
import { NgxSpinnerService } from "ngx-spinner";
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { QuotationApiService } from '@services/rest/quotation-api.service';
import { bindPostCodeValidator, getState } from '@validator/postcode.validator';
import { PaymentResponseModel } from '@model/invoice.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ValidateAlphanumeric } from '@validator/alphanumeric.validator';
import { HttpParams } from '@angular/common/http';
import { BranchModel, BranchRequestModel } from '@model/branch.model';
import { CommonConstant } from '@constants/common-constant';
import { BranchApiService } from '@services/rest/branch-api.service';
import { CustomerRequestModel } from '@model/customer.model';
import { CustomerApiService } from '@services/rest/customer-api.service';
import { UserModel } from '@model/staff.model';
import { ValidateAlphanumericWithDash } from '@validator/alphanumeric-with-dash.validator';
import { Title } from "@angular/platform-browser";
import { encode } from '@utils/EncoderHelper';

@Component({
  selector: 'app-quotation-road-tax',
  templateUrl: 'quotation-road-tax.component.html',
  standalone: false
})

export class QuotationRoadTaxComponent implements OnInit {
  isRunnerServiceDisabled = true;
  isServiceChargeDisabled = true;
  runnerService = 0;
  deliveryService = 0;
  serviceCharge = 0;
  cardWidth = 8;
  current = 0;
  idTextBoxPlaceHolder ="e.g: 801111141111"
  idMask = "000000-00-0000";
  isMobileScreen = false;
  roadTaxAmount = 0;
  totalAmount = 0;
  capacity = 0;
  brand = "";
  model = "";
  form  : UntypedFormGroup;
  personalDetailsForm: UntypedFormGroup;
  submitted = false;
  pdfSubmitted = false;
  verifyCustomerRequestModel : VerifyCustomerRequestModel ={};
  calculateRoadTaxRequestModel: CalculateRoadTaxRequestModel ={};
  dropSpecialCharacters = true;
  paymentResponseModel : PaymentResponseModel = {};
  roadTaxAddEditModel: RoadTaxAddEditModel = {}
  step1Title = "Enter Details";
  step2Title = "Summary";
  step3Title = "Delivery Details";
  mobileStepTitle = "Step 1: Enter Details";
  isVisible = false;
  verifyVehicleReponseModel : VerifyVehicleReponseModel ={};
  roadTaxSettings: RoadTaxSettings = {};
  showRoadTaxRunnerService = true;
  showRoadTaxDeliveryService = true;
  branchSearchModel: BranchRequestModel={};
  branchList: BranchModel[]=[];
  address: string;
  workingHour: string;
  contactNo1: string;
  contactNo2: string;
  whatsapp: string;
  searchModel: CustomerRequestModel={};
  currentUser: UserModel;
  disableShippingOption: boolean = false;

  constructor( 
      private insuranceApiService: InsuranceApiService,
      private roadTaxApiService: RoadTaxApiService,
      private formBuilder: UntypedFormBuilder,
      private spinner: NgxSpinnerService,
      private recaptchaV3Service: ReCaptchaV3Service,
      private quotationService : QuotationApiService,
      private messageService: NzMessageService,
      private branchApiService: BranchApiService,
      private customerApiService: CustomerApiService,
      private titleService: Title
    ) 
  {
  }
  
  ngOnInit(): void {
    this.titleService.setTitle("Brilliant Management Service");
    this.checkIsTokenValid();
    this.getBranch();
    this.getRoadTaxSettings();   

    if (window.screen.width <= 412) { // 768px portrait
      this.isMobileScreen = true;
      this.step1Title = "";
      this.step2Title = "";
    }else{
      this.step1Title = "Enter Details";
      this.step2Title = "Summary";
    }

    this.form = this.formBuilder.group({
      bypassIsm:['0'],
      source:['2'],
      type: ['Car', [Validators.required]],
      vehicleNo: ['', [Validators.required]],
      idType: ['NRIC', [Validators.required]],
      id: ['', [Validators.required]],
      postcode: ['', [Validators.required]],
      contactNo: ['', [Validators.required, Validators.minLength(10)] ],
      email: ['', [Validators.required]],
      companyIdType: ['old'],
      renewalMonth: ['12'],

    });

    this.personalDetailsForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      shippingOption: ['1'],
      roadTaxType: ['1'],
      address1: [''],
      address2: [''],
      state: [''],
      postcode: ['', [Validators.required]],
      contactNo1: ['', [Validators.required] ],
      contactNo2: ['' ],
      remark: [''],
      selfCollectBranchId: [''],
      isSaloon: ['false'],
    });

   bindPostCodeValidator(this.form,'postcode');
   this.disableShippingOption = true;
  }

  get pdf(): { [key: string]: AbstractControl; } {
    return this.personalDetailsForm.controls;
  } 
  
  keyPressAlphaNumeric(event) {
    if(!this.isCompanySelected())
      ValidateAlphanumeric(event);
    else
      ValidateAlphanumericWithDash(event);
  }

  idtypeOnChange(event)
  {
    if(event.target.value =="Passport"){
      this.idTextBoxPlaceHolder ="Enter passport number";
      this.idMask ="";
      this.dropSpecialCharacters = true;  
    }else if(event.target.value =="Company"){
      this.idMask ="";
      this.companyIdMaskingChecking(this.form.get('companyIdType').value);
    }else if(event.target.value =="Police" || event.target.value =="Army"){
      this.idTextBoxPlaceHolder ="Enter uniform professional number"
      this.idMask ="";
      this.dropSpecialCharacters = true;    
    }else if(event.target.value =="NRIC"){
      this.idTextBoxPlaceHolder ="e.g: 801111141111"
      this.idMask ="000000-00-0000";
      this.dropSpecialCharacters = true;    
    }

    this.form.patchValue({id:""});
    this.handleRoadTaxUILogic();
  }

  onSubmit()
  {
    this.spinner.show();    
    this.submitted = true;
    //this.getFormValidationErrors();

    if (this.form.invalid || 
      !this.isIdValid() ||
    !this.isMobileNoValid())  
    {   
      this.spinner.hide();   
      return;    
    }

    this.recaptchaV3Service.execute('importantAction')
    .subscribe((token: string) => {

      this.insuranceApiService
      .VerifyToken(token)
      .subscribe(response => {
        
        if(!response){
          this.showNotification("Recaptcha Error",response);      
        }
        else{
          this.verifyCustomerRequestModel.regNo = this.form.get('vehicleNo').value;
          this.verifyCustomerRequestModel.identityType = this.form.get('idType').value;
          this.verifyCustomerRequestModel.identity = this.form.get('id').value;
          this.verifyCustomerRequestModel.postCode = this.form.get('postcode').value;
          this.verifyCustomerRequestModel.email = this.form.get('email').value;
          this.verifyCustomerRequestModel.contactNo = this.form.get('contactNo').value.toString();
          this.verifyCustomerRequestModel.vehicleType = 0;
          this.verifyCustomerRequestModel.state = "";
          this.verifyCustomerRequestModel.requestType = "RoadTax";    
          this.verifyCustomerRequestModel.renewalMonth = this.form.get('renewalMonth').value.toString();  
          this.verifyCustomerRequestModel.bypassIsm =  this.form.get('bypassIsm').value == "0" ? false : true;


          this.insuranceApiService
          .VerifyVehicleInfo( this.verifyCustomerRequestModel)
          .subscribe(response => {
            if(!response.success)
            {
              this.spinner.hide();
              this.showNotification(response.message,response.success);
            }
            else
            {
              if(this.verifyCustomerRequestModel.bypassIsm){
                this.spinner.hide();
                this.showNotification("Road tax Submitted",true);
                return;
              }

              this.verifyVehicleReponseModel = response;

              this.brand = this.verifyVehicleReponseModel.vehicleInfo.brand;
              this.model = this.verifyVehicleReponseModel.vehicleInfo.model;
              this.capacity = this.verifyVehicleReponseModel.vehicleInfo.capacity;              
              this.personalDetailsForm.patchValue({postcode: this.form.get('postcode').value.trim() },{emitEvent:false});
              this.personalDetailsForm.patchValue({contactNo1: this.form.get('contactNo').value.trim() },{emitEvent:false});
            
              this.personalDetailsForm.patchValue({state: getState(parseInt(this.form.get('postcode').value.trim()))});
              
              if(!this.verifyVehicleReponseModel.vehicleInfo.isWagon){
                this.personalDetailsForm.patchValue({isSaloon: this.verifyVehicleReponseModel.vehicleInfo.isSaloon.toString() },{emitEvent:false});
                this.calculateRoadTaxRequestModel.isSaloon = this.verifyVehicleReponseModel.vehicleInfo.isSaloon;
              }
              else{
                this.personalDetailsForm.patchValue({isSaloon: "false"},{emitEvent:false});
                this.calculateRoadTaxRequestModel.isSaloon = false;
              }
              this.calculateRoadTax();

              if(response.message != null && response.message != "")
                this.showNotification(response.message,response.success);
    

                
                this.spinner.hide();    
                this.next();
              }
      
          });
        }
      });
    });
  }

  get f(): { [key: string]: AbstractControl; } {
    return this.form.controls;
  }

  createRoadTax(){
    this.roadTaxAddEditModel.registrationNo = this.form.get('vehicleNo').value.trim();
    this.roadTaxAddEditModel.identity = this.form.get('id').value.trim();
    this.roadTaxAddEditModel.identityType = this.form.get('idType').value.trim();
    this.roadTaxAddEditModel.contactNo = this.form.get('contactNo').value.trim();
    this.roadTaxAddEditModel.postcode = this.form.get('postcode').value.trim();
    this.roadTaxAddEditModel.email = this.form.get('email').value.trim();
    this.roadTaxAddEditModel.name =  this.personalDetailsForm.get('name').value.trim(); 
    this.roadTaxAddEditModel.vehicleType = this.verifyVehicleReponseModel.vehicleInfo.vehicleType == "Car" ? 0 : 1;
    this.roadTaxAddEditModel.brand =  this.verifyVehicleReponseModel.vehicleInfo.brand;
    this.roadTaxAddEditModel.model =  this.verifyVehicleReponseModel.vehicleInfo.model;
    this.roadTaxAddEditModel.capacity =  this.verifyVehicleReponseModel.vehicleInfo.capacity;
    this.roadTaxAddEditModel.manufacturingYear =  this.verifyVehicleReponseModel.vehicleInfo.manufacturingYear;
    this.roadTaxAddEditModel.roadTaxType =  1;
    this.roadTaxAddEditModel.renewalMonth = parseInt(this.form.get('renewalMonth').value.trim());
    this.roadTaxAddEditModel.renewalAmount =  this.roadTaxAmount;
    this.roadTaxAddEditModel.serviceCharge = this.serviceCharge;
    this.roadTaxAddEditModel.deliveryService = this.deliveryService;
    this.roadTaxAddEditModel.runnerService = this.runnerService;
    this.roadTaxAddEditModel.address1 = "";
    this.roadTaxAddEditModel.address2 = "";
    this.roadTaxAddEditModel.state =  getState(parseInt(this.form.get('postcode').value.trim()));
    this.roadTaxAddEditModel.customerRemark = "";
    this.roadTaxAddEditModel.internalRemark = "";
    this.roadTaxAddEditModel.shippingOption = 1;   
    this.roadTaxAddEditModel.selfCollectBranchId = 204;   
    this.roadTaxAddEditModel.handledBy = null;
    this.roadTaxAddEditModel.source = this.form.get('source').value;
    this.roadTaxAddEditModel.bmsOrderNo = "";
    this.roadTaxAddEditModel.status = 0;
 
    this.roadTaxApiService
    .createRoadTax( this.roadTaxAddEditModel)
    .subscribe(response => {
      this.roadTaxAddEditModel.referenceNumber = response.entity;
    });
  }

  showNotification(message,status){
    if(status === true){
      this.messageService.success(message, {
        nzDuration: 10000
      });
    }
    else{
      this.messageService.error(message, {
        nzDuration: 10000
      });
    }
  }

  pre(): void {
    this.current -= 1;

    if(this.current ==0)
    {
      this.cardWidth = 8;
      this.submitted =false;
      this.roadTaxAddEditModel = {};
   //   this.form.reset();
      this.mobileStepTitle = "Step 1: Enter Details"
    }
    else if(this.current == 1){
      this.cardWidth = 8;
      this.mobileStepTitle = "Step 2: Summary"
      this.resetValue();
    }
  }

  next(): void {
    this.current += 1; 
    this.changeContent();
  }

  changeContent(): void {
    switch (this.current) {
      case 0: {
        this.mobileStepTitle = "Step 1: Enter Details"
        break;
      }
      case 1: {
        this.mobileStepTitle = "Step 2: Summary"
        break;
      }

      default: {
      }
    }
  }

  calculateRoadTax(createRoadTax = true){
    this.calculateRoadTaxRequestModel.isIndividual = this.form.get('idType').value !="Company";
    this.calculateRoadTaxRequestModel.capacity = this.capacity;
    this.calculateRoadTaxRequestModel.renewalMonth = this.form.get('renewalMonth').value;
    this.calculateRoadTaxRequestModel.vehicleType = this.verifyVehicleReponseModel.vehicleInfo.vehicleType == 'Motorcycle' ? 1 : 0;

    this.roadTaxApiService
    .CalculateRoadTax( this.calculateRoadTaxRequestModel)
    .subscribe(response => {
       this.roadTaxAmount = response ;
       this.calculatePremium();

       if(createRoadTax)
        this.createRoadTax();
    });
  }

  calculatePremium()
  {
      this.totalAmount = this.roadTaxAmount + this.runnerService + this.deliveryService + this.serviceCharge;
  }

  roadTaxTypeOnChange(value, editRoadtax = true)
  {
    this.calculateCharges();

    if(value == "0")
    {
      this.personalDetailsForm.patchValue({shippingOption:"0"});
      this.shippingOptionOnChange("0");
      this.disableShippingOption = false;
    }
    else
    {
      this.personalDetailsForm.patchValue({shippingOption:"1"});
      this.disableShippingOption = true;
      //this.shippingOptionOnChange("1");
    }

    if(editRoadtax)
      this.editRoadTax("");
  }

  shippingOptionOnChange(value)
  {
    if(value == "0"){
      this.personalDetailsForm.get('address1').setValidators(Validators.required);
      this.personalDetailsForm.get('address1').updateValueAndValidity();

      this.personalDetailsForm.get('address2').setValidators(Validators.required);
      this.personalDetailsForm.get('address2').updateValueAndValidity();

      this.personalDetailsForm.get('state').setValidators(Validators.required);
      this.personalDetailsForm.get('state').updateValueAndValidity();
    }else{
      this.personalDetailsForm.get('address1').setValidators(null);
      this.personalDetailsForm.get('address1').updateValueAndValidity();

      this.personalDetailsForm.get('address2').setValidators(null);
      this.personalDetailsForm.get('address2').updateValueAndValidity();

      this.personalDetailsForm.get('state').setValidators(null);
      this.personalDetailsForm.get('state').updateValueAndValidity();
    }

    this.calculateCharges();
    this.calculatePremium();

  }

  resetValue()
  {
    this.roadTaxAmount = 0;
    this.totalAmount = 0;
    this.capacity = 0;
    this.calculateRoadTaxRequestModel = {};
  }

  replacePasteValue(event)
  {
    if(!this.isCompanySelected())
      this.form.patchValue({id:event.clipboardData.getData('Text').replace(/-/g, "").replace(/ /g, "").replace(/{/g, "")});
    else
      this.form.patchValue({id:event.clipboardData.getData('Text').replace(/ /g, "").replace(/{/g, "")});

    event.preventDefault();
  }   
  
  replaceRegistrationNoPasteValue(event) 
  {
    this.form.patchValue({vehicleNo:event.clipboardData.getData('Text').replace(/ /g, "")});
    event.preventDefault();
  }   

  isMobileNoValid()
  {
    if(this.form.get('contactNo').value.toString().length < 8 )
    {
      this.form.controls['contactNo'].setErrors({ contactNoInvalidLength : true });
      return false;
    }
    else
    {
      this.form.controls['contactNo'].setErrors(null);
      return true;
    }
  }

  isIdValid()
  {
    if(this.form.get('idType').value == "NRIC" && 
    this.form.get('id').value.toString().length !=12 )
    {
      this.form.controls['id'].setErrors({ icInvalidLength : true });
      return false;
    }
    else
    {
      this.form.controls['id'].setErrors(null);
      return true;
    }
  }

  getVehicleType()
  {
    if(this.form.get('type').value == "Motorcycle")
      return "MOTOR";
    else
      return this.verifyVehicleReponseModel.vehicleInfo.isSaloon ? 'SALOON' :'NON-SALOON'
  }

  getShipmentType()
  {
    if(this.isDeliverySelected() && this.personalDetailsForm.get('roadTaxType').value == '0')
      return "COURIER";
    else if(this.personalDetailsForm.get("shippingOption").value == '1' && this.personalDetailsForm.get('roadTaxType').value == '0')
      return "PICKUP";
    else if(this.personalDetailsForm.get('roadTaxType').value == '1')
      return "DIGITAL";
  }

  getBranchId(){
    return this.personalDetailsForm.get("selfCollectBranchId").value ;
  }

  makePayment(){
    this.pdfSubmitted = true;
    this.getFormValidationErrors();

    if(this.isPhysicalRoadTaxSelected())
    {


      if(this.isDeliverySelected())
      {
        this.personalDetailsForm.get('selfCollectBranchId').clearValidators();
        this.personalDetailsForm.get('selfCollectBranchId').updateValueAndValidity();
        this.personalDetailsForm.get('address1').setValidators([Validators.required, Validators.minLength(5)]);
        this.personalDetailsForm.get('address1').updateValueAndValidity();
  
        this.personalDetailsForm.get('address2').setValidators([Validators.required, Validators.minLength(5)]);
        this.personalDetailsForm.get('address2').updateValueAndValidity();
  
        this.personalDetailsForm.get('postcode').setValidators([Validators.required, Validators.minLength(3)]);
        this.personalDetailsForm.get('postcode').updateValueAndValidity();
  
        this.personalDetailsForm.get('state').setValidators([Validators.required]);
        this.personalDetailsForm.get('state').updateValueAndValidity();
      }
      else{
        this.personalDetailsForm.get('selfCollectBranchId').setValidators([Validators.required]);
        this.personalDetailsForm.get('selfCollectBranchId').updateValueAndValidity();
        this.personalDetailsForm.get('address1').clearValidators();
        this.personalDetailsForm.get('address1').updateValueAndValidity();
        this.personalDetailsForm.get('address2').clearValidators();
        this.personalDetailsForm.get('address2').updateValueAndValidity();
        this.personalDetailsForm.get('postcode').clearValidators();
        this.personalDetailsForm.get('postcode').updateValueAndValidity();
        this.personalDetailsForm.get('state').clearValidators();
        this.personalDetailsForm.get('state').updateValueAndValidity();
      }
    }
    else
    {
      this.personalDetailsForm.get('selfCollectBranchId').clearValidators();
      this.personalDetailsForm.get('selfCollectBranchId').updateValueAndValidity();
      this.personalDetailsForm.get('address1').clearValidators();
      this.personalDetailsForm.get('address1').updateValueAndValidity();
      this.personalDetailsForm.get('address2').clearValidators();
      this.personalDetailsForm.get('address2').updateValueAndValidity();
      this.personalDetailsForm.get('postcode').clearValidators();
      this.personalDetailsForm.get('postcode').updateValueAndValidity();
      this.personalDetailsForm.get('state').clearValidators();
      this.personalDetailsForm.get('state').updateValueAndValidity();
    }

    if (this.personalDetailsForm.invalid)    
      return;    

    this.spinner.show();

    let contactNo = this.form.get('contactNo')?.value?.trim();

    if (contactNo && !contactNo.startsWith('6')) {
      contactNo = '6' + contactNo;
    }

    // const payload = new HttpParams()
    // .set('accessToken', 'eTdy1nT7TcOTp7LCDISfNteHWpZHketK')
    // .set('module',  '/sales/insert')
    // .set('clientIdNo', this.form.get('id').value.trim())
    // .set('clientIdType',  this.form.get('idType').value.toUpperCase())
    // .set('clientName',   this.personalDetailsForm.get('name').value.trim())
    // .set('contactNo',  contactNo)
    // .set('vehicleType', this.getVehicleType())
    // .set('vehicleNo', this.form.get('vehicleNo').value.trim())
    // .set('roadTaxMonth', parseInt(this.form.get('renewalMonth').value))
    // .set('roadTaxAmount',  this.roadTaxAmount) 
    // .set('shipmentType', this.getShipmentType()) 
    // .set('branchId', this.getShipmentType() == "PICKUP" ? this.getBranchId() : "") 
    // .set('shipmentFee', this.deliveryService) 
    // .set('deliveryAddress', this.personalDetailsForm.get('address1').value.trim()+" "+ 
    //                         this.personalDetailsForm.get('address2').value.trim()+" "+
    //                         this.personalDetailsForm.get('postcode').value.trim()) 
    // .set('notesPublic',  this.personalDetailsForm.get('remark').value)
   
    // fetch("https://bmsroadtax.com/api/v3/index.php", {
    //     method: 'POST',
    //     headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //     body:  payload.toString()
    // })
    // .then(res =>res.text())
    // .then((body) => {
   
    //   let jsonObj = JSON.parse(body);
    //   let paymentModel = jsonObj as PaymentResponseModel;

      this.editRoadTax("",true,1);
  //   });
  }

  editRoadTax(bmsOrderNo, routeToPayment = false, status: number =0){
  
    this.roadTaxAddEditModel.registrationNo = this.form.get('vehicleNo').value.trim();
    this.roadTaxAddEditModel.identity = this.form.get('id').value.trim();
    this.roadTaxAddEditModel.identityType = this.form.get('idType').value.trim();
    this.roadTaxAddEditModel.contactNo = this.form.get('contactNo').value.trim();
    this.roadTaxAddEditModel.postcode = this.form.get('postcode').value.trim();
    this.roadTaxAddEditModel.name =  this.personalDetailsForm.get('name').value.trim(); 
    this.roadTaxAddEditModel.vehicleType = this.verifyVehicleReponseModel.vehicleInfo?.vehicleType == "Car" ? 0 : 1;
    this.roadTaxAddEditModel.brand =  this.verifyVehicleReponseModel.vehicleInfo?.brand;
    this.roadTaxAddEditModel.model =  this.verifyVehicleReponseModel.vehicleInfo?.model;
    this.roadTaxAddEditModel.capacity =  this.verifyVehicleReponseModel.vehicleInfo?.capacity;
    this.roadTaxAddEditModel.manufacturingYear =  this.verifyVehicleReponseModel.vehicleInfo?.manufacturingYear;
    this.roadTaxAddEditModel.roadTaxType =  this.personalDetailsForm.get('roadTaxType').value;
    this.roadTaxAddEditModel.renewalMonth = parseInt(this.form.get('renewalMonth').value.trim());
    this.roadTaxAddEditModel.renewalAmount =  this.roadTaxAmount;
    this.roadTaxAddEditModel.serviceCharge = this.serviceCharge;
    this.roadTaxAddEditModel.deliveryService = this.deliveryService;
    this.roadTaxAddEditModel.runnerService = this.runnerService;
    this.roadTaxAddEditModel.address1 = this.personalDetailsForm.get('address1').value.trim();
    this.roadTaxAddEditModel.address2 = this.personalDetailsForm.get('address2').value.trim();
    this.roadTaxAddEditModel.state = this.personalDetailsForm.get('state').value.trim();
    this.roadTaxAddEditModel.customerRemark = this.personalDetailsForm.get('remark').value.trim();
    this.roadTaxAddEditModel.internalRemark = "";
    this.roadTaxAddEditModel.shippingOption = this.personalDetailsForm.get('shippingOption').value;   
    this.roadTaxAddEditModel.handledBy = null;
    this.roadTaxAddEditModel.source = this.form.get('source').value;
    this.roadTaxAddEditModel.bmsOrderNo = bmsOrderNo;
    this.roadTaxAddEditModel.status = status;
    this.roadTaxAddEditModel.isSaloon =  this.personalDetailsForm.get('isSaloon').value == "true" ? true : false;
    

    if(!this.isDeliverySelected() && this.isPhysicalRoadTaxSelected())
    {
      var selfCollectBranchId = this.personalDetailsForm.get('selfCollectBranchId').value;

      if(selfCollectBranchId == "")
        this.roadTaxAddEditModel.selfCollectBranchId = null;
      else
          this.roadTaxAddEditModel.selfCollectBranchId = this.personalDetailsForm.get('selfCollectBranchId').value;   
    }

    this.roadTaxApiService
    .editRoadTaxCustomer( this.roadTaxAddEditModel)
    .subscribe(response => {
      this.spinner.hide();

      if(response.success){
        if(routeToPayment)
          window.location.href = "https://quotation.bmsroadtax.com/#/payment?ref="+  response.entity;        
      }else{
        this.showNotification("Unable to redirect to payment screen, please contact support.", false);
      }
    });
  }
  
  getFormValidationErrors() {
    Object.keys(this.personalDetailsForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.personalDetailsForm.get(key)?.errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
         console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {

    this.isVisible = false;
    this.onSubmit();
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  isCompanySelected(){
    return this.form.get('idType').value == "Company";
  }

  isDeliverySelected(){
    return this.personalDetailsForm.get('shippingOption').value == "0";
  }

  isPhysicalRoadTaxSelected(){
    return this.personalDetailsForm.get('roadTaxType').value == "0";
  }

  companyIdtypeOnChange(event){
    this.form.patchValue({id:""});
    this.companyIdMaskingChecking(event.target.value );
  }

  companyIdMaskingChecking(value){
    if(value == "old")
    {
      this.idTextBoxPlaceHolder ="e.g: 1234567-A"
    }
    else{
      this.idMask ="000000000000";
      this.idTextBoxPlaceHolder ="e.g: 202005123456"
    }
  }

  getRoadTaxSettings()
  {
    this.roadTaxApiService.roadTaxSettings().subscribe(response => {
      this.roadTaxSettings = response.entity;
      this.handleRoadTaxUILogic();
      this.shippingOptionOnChange("0"); 
    });
  }

  handleRoadTaxUILogic()
  {
      if(this.roadTaxSettings.disableNRICPhysicalRoadTax && this.isNricSelected())
      {
        this.personalDetailsForm.patchValue({roadTaxType: "1" });
        this.personalDetailsForm.controls['roadTaxType'].disable();
      }
      else if(this.isCompanySelected() || this.isPassportSelected())
      {
          this.personalDetailsForm.patchValue({roadTaxType: "0"});
          this.personalDetailsForm.patchValue({shippingOption: "1"});
          this.roadTaxTypeOnChange("0",false);
          this.personalDetailsForm.controls['roadTaxType'].disable(); 
      }
  }

  calculateCharges()
  {
    if(this.isPhysicalRoadTaxSelected())
    {
      if(!this.roadTaxSettings.runnerFeeWaivedWithoutInsurance)
        this.runnerService = this.roadTaxSettings.runnerFeeWithoutInsurance;
      else
        this.runnerService = 0;

      if(!this.roadTaxSettings.deliveryFeeWaivedWithoutInsurance)
        this.deliveryService = this.roadTaxSettings.deliveryFeeWithoutInsurance;
      else
        this.deliveryService = 0;

      if(!this.isDeliverySelected())
        this.deliveryService = 0;

      this.serviceCharge = 0;
    }
    else{
        this.runnerService = 0;
        this.deliveryService = 0;

        if(!this.roadTaxSettings.serviceChargeWaivedWithoutInsurance)
          this.serviceCharge = this.roadTaxSettings.serviceChargeWithoutInsurance;
        else
          this.serviceCharge = 0;
    }
  }
  
  isPassportSelected()
  {
    return this.form.get('idType').value == "Passport";
  }

  isNricSelected()
  {
    return this.form.get('idType').value == "NRIC";
  }

  getRenewalMonth()
  {
    return this.form.get('renewalMonth').value;
  }

  getBranch(){
    this.branchSearchModel.pageIndex = CommonConstant.MIN_PAGE_INDEX;;
    this.branchSearchModel.pageSize = CommonConstant.MAX_PAGE_SIZE;

    this.branchApiService.getBranchList(this.branchSearchModel)
    .subscribe(response => {
        this.branchList = response.entity.items;
    });
  }

  branchOnChange(value){
   
    var result = this.branchList.find(x => x.id ==value);

    if(result != null)
    {
      this.address = result.address;
      this.contactNo1 = result.contactNo1;
      this.contactNo2 = result.contactNo2;
      this.workingHour = result.workingHour;
      this.whatsapp = result.whatsapp;
    }
  }

  SearchCustomer(){
    this.searchModel.identity = this.form.get('id').value.trim();
    this.searchModel.registrationNo =  this.form.get('vehicleNo').value.trim();
    this.customerApiService
      .getCustomerList(this.searchModel)
      .subscribe(response => {

        if(response.entity.items.length > 0)
        {
          this.form.patchValue({contactNo: response.entity.items[0].contactNo1 },{emitEvent:false})
          this.form.patchValue({postcode: response.entity.items[0].postcode },{emitEvent:false})
          this.form.patchValue({email: response.entity.items[0].email },{emitEvent:false})
        }
        else{
          this.form.patchValue({contactNo: "" },{emitEvent:false})
          this.form.patchValue({postcode: ""  },{emitEvent:false})
          this.form.patchValue({email: ""  },{emitEvent:false})
        }
      });
  }

  checkIsTokenValid()
  {
    this.insuranceApiService
    .ping()
    .subscribe(response => {
        this.currentUser = response.entity;
    });
  }

  vehicleTypeOnChange()
  {
    this.calculateRoadTaxRequestModel.isSaloon = this.personalDetailsForm.get('isSaloon').value == "true"? true : false;
    this.calculateRoadTax(false);
  }

  
  isLoginAsAdmin()
  {
    var result = this.currentUser?.name != null;

    if(!result)
      this.form.patchValue({source:"2"});

    return result;
  }

}
